import React from 'react';

const recognition = [
  { name: 'USA TODAY', detail: 'Prior digital strategy experience', href: 'https://www.linkedin.com/in/dakotadigitalcowboy/' },
  { name: 'Second Street', detail: '2018 Best Birthday Email winning campaign; Joe’s case study for Aberdeen News Company', href: 'https://lab.secondstreet.com/articles/aberdeen-birthday-email/' },
  { name: 'Alignable', detail: '2025 Local Business Person of the Year — South Dakota state winner', href: 'https://www.alignable.com/forum/alignable-announces-top-state-provincial-local-business-leaders' },
];

export default function Credibility() {
  return (
    <section id="recognition" aria-labelledby="recognition-title" className="border-t border-[#244A49]/15 px-6 py-12">
      <div className="mx-auto max-w-5xl">
        <p className="text-sm font-semibold text-[#244A49]">Joe Moore · Professional background</p>
        <h2 id="recognition-title" className="mt-3 text-2xl font-bold text-[#101F1F]">Experience & recognition</h2>
        <dl className="mt-6 divide-y divide-[#244A49]/15">
          {recognition.map(({ name, detail, href }) => <div key={name} className="grid gap-2 py-5 sm:grid-cols-[1fr_1.618fr] sm:gap-8"><dt className="font-semibold text-[#101F1F]">{name}</dt><dd className="leading-7 text-[#244A49]">{detail}. <a href={href} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center font-semibold underline underline-offset-4">View {name} background ↗</a></dd></div>)}
        </dl>
      </div>
    </section>
  );
}